export default function copyToClipboard(email) {
    // navigator.clipboard.writeText('hello there');
    document.querySelectorAll('[data-copy]').forEach((element) => {
        element.addEventListener('click', (event) => {
            let copyType = element.getAttribute('data-copy');
            let copyValue = null;
            if(copyType == "email") {
                copyValue = email;
            }
            if(copyType == "page-url") {
                copyValue = window.location.href + '?utm_source=copybutton';
            }
            console.log('Copying ' + copyValue);
            navigator.clipboard.writeText(copyValue);
            element.querySelector('span').innerHTML = 'Copied!';
        });
    });
}